/**
 * Build a srcset string from pre-imported image URLs at 1x, 2x, and 3x.
 * @param {string} img1x - Imported 1x image URL
 * @param {string} img2x - Imported 2x image URL
 * @param {string} img3x - Imported 3x image URL
 * @returns {string[]} Array of srcset descriptors for use in dashing-ui banner components
 */
export function srcSet(img1x, img2x, img3x) {
  return [`${img1x} 1x`, `${img2x} 2x`, `${img3x} 3x`];
}
